export default "__VITE_ASSET__7183d305__"